import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService, AuthService, ResourceService } from '@services/index.service';
import { environment } from "@environments/environment";
import { PortalConfigurationService } from '../../services/portal-configuration/portal-configuration.service';

/** Página estática que tan sólo muestra la información que desaea el propietario del portal */
@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html'
})
export class FaqComponent implements OnInit {

  faqsInDatabase: boolean = false;

  constructor(public _userService: UserService, public _authService: AuthService,
    public _resourceService: ResourceService, public translate: TranslateService,
    public _portalConfigurationService: PortalConfigurationService) {
    if (environment.ADMINNAVBAR.HAS && environment.ADMINNAVBAR.PORTAL_CONFIGURATION) {
      this.faqsInDatabase = true;
      this._portalConfigurationService.getFaqs();
    }
  }

  ngOnInit() {
    delete this._userService.danger;
    delete this._userService.warning;
    delete this._userService.success;
    delete this._authService.alert;

  }

}
